import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Box } from "@material-ui/core";

function TableContentNoData({ show, children }) {
    if (!show) return null;
    return (
        <Box width="100%" mt={10}>
            <Typography align='center' variant='h5'>{children}</Typography>
        </Box>
    );
}

TableContentNoData.propTypes = {
    show: PropTypes.bool.isRequired
};

export default TableContentNoData;
